// src/components/ui/CheckField.jsx
//
// R5 B2.5 — rule 9: a checkbox is a 16px box with its label BESIDE it and
// its help under the label — never "Deceased:" then a box (the operator:
// "the Deceased checkbox is weird"). Every prop that is not the kit's own
// goes to the <input type="checkbox"> itself (checked, onChange, disabled,
// name, data-*), so a caller's control is exactly the box it was.
import React from 'react';
import PropTypes from 'prop-types';
import { useFieldId } from './Field';
import './kit.css';

export default function CheckField({
  label, help, error, id, className, inputClassName, 'aria-describedby': describedBy, ...inputProps
}) {
  const baseId = useFieldId('ff-check');
  const boxId = id || `${baseId}-box`;
  const helpId = help ? `${baseId}-help` : null;
  const errorId = error ? `${baseId}-error` : null;
  const describe = [describedBy, helpId, errorId].filter(Boolean).join(' ') || undefined;
  return (
    <div className={`ff-checkfield${className ? ` ${className}` : ''}`}>
      <input
        type="checkbox"
        id={boxId}
        className={`ff-checkfield__box${inputClassName ? ` ${inputClassName}` : ''}`}
        aria-describedby={describe}
        {...inputProps}
      />
      <label className="ff-checkfield__label" htmlFor={boxId}>{label}</label>
      {help ? <p className="ff-checkfield__help" id={helpId}>{help}</p> : null}
      {error ? <p className="ff-checkfield__error" id={errorId} role="alert">{error}</p> : null}
    </div>
  );
}

CheckField.propTypes = {
  /** The words beside the box. */
  label: PropTypes.node.isRequired,
  /** 12px muted text under the label (the reason a box is locked, say). */
  help: PropTypes.node,
  error: PropTypes.node,
  /** The checkbox's id (one is made when absent). */
  id: PropTypes.string,
  className: PropTypes.string,
  /** Extra class on the <input> itself. */
  inputClassName: PropTypes.string,
  'aria-describedby': PropTypes.string,
};
